module.exports = __webpack_public_path__ + "static/stars-47437cd5ae9a123df554fc3835de2b94.jpg";